export default __webpack_public_path__ + "static/media/icons8-css3.8fe37b34.svg";